export const GET_ENGAGEMENT_REQUEST_REQUEST = "GET_ENGAGEMENT_REQUEST_REQUEST"
export const GET_ENGAGEMENT_REQUEST_SUCCESS = "GET_ENGAGEMENT_REQUEST_SUCCESS"
export const GET_ENGAGEMENT_REQUEST_FALUIRE = "GET_ENGAGEMENT_REQUEST_FALUIRE"

export const PATCH_ENGAGEMENT_REQUEST = "PATCH_ENGAGEMENT_REQUEST"
export const PATCH_ENGAGEMENT_SUCCESS = "PATCH_ENGAGEMENT_SUCCESS"
export const PATCH_ENGAGEMENT_FALUIRE = "PATCH_ENGAGEMENT_FALUIRE"